import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWoning = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Woning_svg__a)">
      <mask
        id="Woning_svg__b"
        width={22}
        height={26}
        x={9}
        y={7}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M20 7 9 15v18h4V21.25h7V33h11V15z"
        />
      </mask>
      <g mask="url(#Woning_svg__b)">
        <path
          fill="#F7A941"
          d="M13.43 26.07 1.19 19 8.26 6.75z"
        />
        <path
          fill="#F7A941"
          d="M-5.89 31.25 1.19 19l12.24 7.07z"
        />
        <path
          fill="#F18700"
          d="M32.75 20.9 20.5 13.83l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m8.26 6.75 12.24 7.08-7.07 12.24z"
        />
        <path
          fill="#F18700"
          d="m13.43 26.07 7.07-12.24 12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="M27.57 1.58 20.5 13.83 8.26 6.75z"
        />
        <path
          fill="#F18700"
          d="m13.43 26.07 12.25 7.07-7.07 12.25zM37.93 40.22l-12.25-7.08 7.07-12.24z"
        />
        <path
          fill="#F18700"
          d="m32.75 20.9-7.07 12.24-12.25-7.07z"
        />
        <path
          fill="#F7A941"
          d="M18.61 45.39 6.36 38.32l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="M13.43 26.07 6.36 38.32l-12.25-7.07z"
        />
        <path
          fill="#F18700"
          d="m27.57 1.58 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="M46.89-3.6 39.82 8.65 27.57 1.58z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Woning_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWoning);

export default ForwardRef;
